import React, {useState} from 'react';
import s from '../FinancialReport.module.css';
import styleTableGrid from '../../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import style from '../../PaperworkList/PaperworkList.module.css';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';
import SimpleReportTableRowEl from './rows/SimpleReportTableRowEl';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';
import {FinReportType} from '../../../types/StoreReportTypes';

type Props = {
	title: string;
	data: FinReportType[];
	columns: string[];
	fields: (keyof FinReportType)[];
	columnsCount?: number;
};

const SimpleReportTable: React.FC<Props> = ({
	title,
	data,
	columns,
	fields,
	columnsCount,
}) => {
	const {t} = useTranslation();
	const [showAll, setShowAll] = useState(false);
	const visibleData = showAll ? data : data.slice(0, 4);

	const gridClass = columnsCount
		? `simpleTableRow${columnsCount}`
		: 'simpleTableRow';
	
	const gridTemplateColumns = columnsCount ? `repeat(${columnsCount}, 1fr)` : undefined;

	return (
		<>
			<div className={s.title}>{title}</div>
			<div className={s.reportTableContainer}>
				{/* Обгортка для адаптивного горизонтального скролу */}
				<div className={s.tableWrapper}>
					<div className={styleTableGrid.tableGrid}>
						<GridTableHead 
							columns={columns}
							gridTemplateColumns={gridTemplateColumns}
							customClassName={styleTableGrid.tableRow}
						/>
						{visibleData.map((row, index) => (
							<SimpleReportTableRowEl
								key={row.sold + index}
								row={row}
								fields={fields}
								gridClass={gridClass}
							/>
						))}

						{!showAll && data.length > 4 && (
							<div className={style.buttonWrapper}>
								<LightGreenButton
									type={'button'}
									text={t('Дивитись більше')}
									onClick={() => setShowAll(true)}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default SimpleReportTable;

